import {FormioBase} from "./formiobase";

export class Day extends FormioBase {
  public inputType = "day";
  public title = "Day";
  public icon = "fa fa-calendar";
  public schema: any = {
    title: "day",
    components: [{
      input: true,
      inputType: "day",
      tableView: true,
      label: "Day of Birth",
      key: undefined,
      fields: {
        day: {
          type: "number",
          placeholder: "",
          required: true,
        },
        month: {
          type: "select",
          placeholder: "",
          required: true,
        },
        year: {
          type: "number",
          placeholder: "",
          required: true,
        },
      },
      dayFirst: true,
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        custom: "",
      },
      type: "day",
      hideLabel: false,
      labelPosition: "leftleft",
      inputsLabelPosition: "top",
      tags: [],
      properties: {},
      useLocaleSettings: true,
      defaultValue: "1/1/2018",
      labelWidth: 30,
      labelMargin: 3,
      customClass: "ds-day",
    }],
  };
}
